module.exports = {
  fr: {
    ariaLabel: "Gestion des cookies",
    text: "Nous utilisons des cookies de mesure d'audience et publicitaires (Google Analytics, Google Ads) pour comprendre l'utilisation du site et mesurer l'efficacité de nos campagnes. Vous pouvez accepter ou refuser ces cookies non essentiels à tout moment.",
    accept: "Accepter",
    refuse: "Refuser",
    manage: "Gérer les cookies",
  },
  en: {
    ariaLabel: "Cookie settings",
    text: "We use audience-measurement and advertising cookies (Google Analytics, Google Ads) to understand site usage and measure our campaigns. You can accept or refuse these non-essential cookies at any time.",
    accept: "Accept",
    refuse: "Refuse",
    manage: "Manage cookies",
  },
  ru: {
    ariaLabel: "Настройки cookie",
    text: "Мы используем файлы cookie для аналитики и рекламы (Google Analytics, Google Ads), чтобы понимать использование сайта и измерять эффективность наших кампаний. Вы можете принять или отклонить эти необязательные файлы cookie в любой момент.",
    accept: "Принять",
    refuse: "Отклонить",
    manage: "Управление cookie",
  },
};
